import type {TreePayload} from '@github-ui/code-view-types'
import React, {useMemo} from 'react'

const TreeContext = React.createContext({} as TreePayload)

export function useCurrentTree() {
  return React.use(TreeContext)
}

export function CurrentTreeProvider({payload, children}: React.PropsWithChildren<{payload: TreePayload}>) {
  const {items, readme, totalCount, templateDirectorySuggestionUrl, showBranchInfobar} = payload

  const value = useMemo<TreePayload>(
    () => ({
      items,
      readme,
      totalCount,
      templateDirectorySuggestionUrl,
      showBranchInfobar,
    }),
    [items, readme, totalCount, templateDirectorySuggestionUrl, showBranchInfobar],
  )

  return <TreeContext value={value}>{children}</TreeContext>
}
